import easyRecLogo from "../assets/easyrec_icon_trimed_256.png";
import { useTranslation } from "../hooks/useTranslation";
import appStyles from "../styles/styles";
import LanguageSwitcher from "./LanguageSwitcher";

/** アプリ上部のヘッダー（ロゴ・タイトル・UI言語切替） */
export const AppHeader = () => {
	const t = useTranslation();

	return (
		<header className={appStyles.header}>
			<div className={appStyles.headerBackground} />
			<div className={appStyles.headerBackgroundPattern} />
			<div className={`${appStyles.headerContent} flex flex-col items-center`}>
				<div className="w-full flex justify-end mb-2">
					<LanguageSwitcher />
				</div>
				<h1 className={appStyles.title}>
					<img src={easyRecLogo} alt="EasyRec Logo" className="inline-block mr-3 h-12 pb-1" />
					EasyRec
				</h1>
				<p className={appStyles.subtitle}>{t.subtitle}</p>
			</div>
		</header>
	);
};

export default AppHeader;
